import MultiColPointDataTable from '@components/_shared/MultiColPointDataTable';
import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import UIBox from '@components/_shared/UIBox';
import useGetInternalWidgetConfig from '@hooks/api/queries/widgets/useGetInternalWidgetConfig';
import { useCurrentTrackerDeviceContext } from '@hooks/useCurrentTrackerDevice';
import { Grid2, Typography } from '@mui/material';
import QueryKeys from '@src/constants/queryKeys';
import { WidgetTypePointList } from '@src/types/Widget';
import { useMemo } from 'react';

export default function MasterTrackerDetail() {
  const { currentTrackerDevice } = useCurrentTrackerDeviceContext();
  const { deviceId: currentTrackerId } = currentTrackerDevice || {
    deviceId: 'master_tracker_1',
  };

  const {
    data: widgetConfig,
    isLoading,
    isError,
  } = useGetInternalWidgetConfig<WidgetTypePointList>(
    `masterTrackerDetail`,
    {
      sourceDeviceId: currentTrackerId,
    },
    {
      queryKeys: [QueryKeys.masterTracker, currentTrackerId],
      enabled: !!currentTrackerId,
    },
  );

  const memoizedDataPoints = useMemo(
    () => widgetConfig?.dataPoints || [],
    [widgetConfig?.dataPoints],
  );

  return (
    <UIBox
      header={widgetConfig?.header}
      subheader={currentTrackerDevice?.name}
      isLoading={isLoading || (!isLoading && !widgetConfig && !isError)}
      isError={isError || (!isLoading && !widgetConfig)}
      style={{ minHeight: 'min-content' }}
    >
      <Grid2 container justifyContent='space-evenly'>
        {memoizedDataPoints.length > 0 ? (
          <MultiColPointDataTable dataPointsMatrix={memoizedDataPoints} />
        ) : (
          <Typography>
            <FormattedAlias id='No data points set up for this widget.' />
          </Typography>
        )}
      </Grid2>
    </UIBox>
  );
}
